<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section dashboard">
    <div class="pagetitle text-center">
      <h1>Open Graph Checker - Twitter Card Checker</h1>
      <div class="div-page-description"><h5>Elevate your social media presence! Our free Open Graph and Twitter Cards Checker ensures your website shines on platforms like Facebook and Twitter.</h5></div>
    </div>
    <div class="container">
      <div class="row">

        <div class="col-lg-11 col-9">
          <form class="form-inline">
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon3">https://</span>

              <input class="form-control" type="search" placeholder="Enter URL without https or http" aria-label="Search" name="url" [(ngModel)]="url" aria-describedby="basic-addon3">
            </div>
          </form>
        </div>
        <div class="col-lg-1 col-3">
          <app-spinner *ngIf="showCheckSeoModalSpinner"></app-spinner>
          <button class="btn btn-primary" type="submit" *ngIf="!showCheckSeoModalSpinner" (click)="checkOpenGraph()">Check</button>
        </div>
      </div>

      <div class="row mt-3" *ngIf="seoResults!=null">

        <div class="col-lg-12">
          <span *ngIf="seoResults.openGraphMetaTags!=null">
            <i *ngIf="seoResults.openGraphMetaTags!=null && seoResults.openGraphMetaTags.length>0" class="bi bi-check-circle-fill text-success"></i>
            Open graph meta tags found.
          </span>

          <span *ngIf="seoResults.openGraphMetaTags==null"><i class="bi bi-x-circle-fill text-danger"></i> Open graph meta tags not found.</span>

          <table class="table table-bordered mt-2" *ngIf="seoResults.openGraphMetaTags!=null && seoResults.openGraphMetaTags.length>0">
            <tbody>
              <tr *ngFor="let openGraphMetaTag of seoResults.openGraphMetaTags">
                <td>{{openGraphMetaTag.key}}</td>
                <td>{{openGraphMetaTag.value}}</td>
              </tr>
            </tbody>
          </table>

          <span *ngIf="seoResults.twitterGraphMetaTags!=null && seoResults.twitterGraphMetaTags.length>0">
            <i *ngIf="seoResults.twitterGraphMetaTags!=null && seoResults.twitterGraphMetaTags.length>0" class="bi bi-check-circle-fill text-success"></i> Twitter card meta tags found.
          </span>
          <span *ngIf="seoResults.twitterGraphMetaTags==null || seoResults.twitterGraphMetaTags.length==0"><i class="bi bi-x-circle-fill text-danger"></i> Twitter card meta tags not found.</span>
          <br />
          <table class="table table-bordered mt-2" *ngIf="seoResults.twitterGraphMetaTags!=null  && seoResults.twitterGraphMetaTags.length>0">
            <tbody>
              <tr *ngFor="let twitterGraphMetaTag of seoResults.twitterGraphMetaTags">
                <td>{{twitterGraphMetaTag.key}}</td>
                <td>{{twitterGraphMetaTag.value}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row mt-3">

        <div class="col-lg-12">

          <div class="accordion accordion-flush" id="faq-group-1">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-1" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  About Open Graph Checker & Twitter Card Checker Checker Tool
                </button>
              </h2>
              <div id="faqs-1" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Social media has become a powerful force in shaping online presence, and optimizing your website for social sharing is paramount. In this sections, we'll delve into the importance of Open Graph meta tags and introduce you to our game-changing tool: the Open Graph Checker.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-2" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  Why Open Graph Meta Tags Matter?
                </button>
              </h2>
              <div id="faqs-2" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Open Graph meta tags are snippets of code that provide social media platforms with information about your website content when shared. They play a crucial role in ensuring that your shared content appears visually appealing and accurately represents your brand. The Open Graph Checker tool becomes your go-to solution for ensuring that your Open Graph meta tags are optimized for maximum impact on platforms like Facebook and LinkedIn.</p>
                  <p>Moreover, the tool offers insights into additional Open Graph meta tags, such as og:image, og:title, and og:description, allowing you to fine-tune your content for a compelling social media presence.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-3" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  Twitter Cards: Enhancing Visibility on Twitter
                </button>
              </h2>
              <div id="faqs-3" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Twitter, another social media giant, utilizes Twitter Cards to enhance the appearance of shared links. The Open Graph Checker tool extends its functionality to include Twitter Cards, ensuring that your content stands out on this dynamic platform as well. Discover how to leverage Twitter Cards alongside Open Graph meta tags for a comprehensive social media optimization strategy.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-4" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  Optimizing Your Social Media Presence
                </button>
              </h2>
              <div id="faqs-4" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>In conclusion, the Open Graph Checker tool equips you with the means to optimize your website's social media presence. Whether it's ensuring eye-catching visuals on Facebook or standing out with Twitter Cards on Twitter, this tool is your key to elevating your content's visibility across social platforms.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<app-alert [showMessage]="showMessage" [message]="message" [alertType]="alertType">
</app-alert>
<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
